import {Component, Input, OnInit} from '@angular/core';
import {UserGroup} from '../../../../lib/user-group.service';
import {QueryFieldModel} from '../../../../util/core-utils';
import {OrderType, QueryResult} from '../../../../lib/util/services';
import {CustomerRecord, CustomerRecordService} from '../../../../lib/customer/customer-record.service';
import {Set} from "immutable";
import {MatDialog} from "@angular/material/dialog";
import {RightResolver, RightService} from "../../../../lib/right.service";
import {
  CustomerRecordOwnerModifyDialogComponent
} from "../customer-record-owner-modify-dialog/customer-record-owner-modify-dialog.component";
import {RightModel} from "../../../../app.rights";

@Component({
  selector: 'app-customer-record-owner-group-list',
  templateUrl: './customer-record-owner-group-list.component.html',
  styleUrls: ['./customer-record-owner-group-list.component.scss']
})
export class CustomerRecordOwnerGroupListComponent implements OnInit {

  UserGroup = UserGroup;

  pagingId = 'customerRecordOwnerGroupList';

  @Input()
  customerId: number;

  @Input()
  customerRecordId: number;

  @Input()
  readonly: boolean = true;


  queryModel: QueryFieldModel<UserGroup.OrderField> =
    new QueryFieldModel(UserGroup.OrderField.NAME, OrderType.ASC);

  groupList: CustomerRecord.OwnerGroupData[] = [];

  @Input()
  rightModel: RightModel = RightModel.empty();


  constructor(private customerRecordService: CustomerRecordService,
              private dialog: MatDialog) {
  }

  ngOnInit(): void {
  }

  initComponent() {
    this.loadList();
  }

  loadList(pageNumber?: number) {
    const requestedPage = pageNumber ? pageNumber : this.queryModel.currentPage;
    const order = this.queryModel.getOrder();
    this.customerRecordService.queryOwnerUserGroups({
      customerId: this.customerId,
      customerRecordId: this.customerRecordId,
      orders: Set.of(order),
      paging: requestedPage ? {
        pageNumber: requestedPage,
        numberOfItems: this.queryModel.itemsPerPage
      } : undefined,
      fields: Set.of('id', 'name', 'disabled')
    }).subscribe((result: QueryResult<CustomerRecord.OwnerGroupData>) => {
      this.groupList = result.items.toArray();
      this.queryModel.currentPage = requestedPage;
      this.queryModel.totalNumberOfItems = result.pagingResult.totalNumberOfItems;
      this.queryModel.currentNumberOfItems = result.pagingResult.currentNumberOfItems;
    });
  }

  orderBy(field: UserGroup.OrderField) {
    this.queryModel.onOrderFieldChanged(field);
    this.loadList(1);
  }

  pageChanged(selectedPage: number) {
    this.loadList(selectedPage);
  }

  itemsPerPageChanged(itemsPerPage: number) {
    this.queryModel.itemsPerPage = itemsPerPage;
    this.loadList(1);
  }

  ownerUserGroupAddClicked() {
    CustomerRecordOwnerModifyDialogComponent.openDialog(this.dialog,
      {
        customerRecordIds: [this.customerRecordId],
        allowUserChange: false,
        allowUserGroupChange: true
      }, (result) => {
        if (result && result.success) {
          this.loadList();
        }
      });
  }

  groupDeleteClicked(group: CustomerRecord.OwnerGroupData) {
    this.customerRecordService.changeOwners({
      customerRecordIds: Set.of(this.customerRecordId),
      ownerUserGroupIds: Set.of(group.id),
      changeType: 'DELETE'
    }).subscribe(result => {
      this.loadList();
    });

  }
}
